module.exports = __webpack_public_path__ + "img/bed.b3a4ce24.png";